import { render, staticRenderFns } from "./SetupOfficials.vue?vue&type=template&id=29e3a591&scoped=true&"
import script from "./SetupOfficials.vue?vue&type=script&lang=js&"
export * from "./SetupOfficials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e3a591",
  null
  
)

export default component.exports